/**
 * Das Nachlausch-Fenster — EINE Quelle für die Einstellungen, die Karte und
 * den Server. (26.09.2026, Ticket 2668)
 *
 * Martin, auf der Autobahn: *„Nach JEDER gesprochenen Antwort bleibt das
 * Mikro noch etwa 2–3 Sekunden lauschend offen … Bleibt es still, schließt
 * sich das Mikro wieder."* Gilt, wenn das Mikro VON SELBST aufging (nach
 * einer Frage oder in der Stufe „Jev entscheidet“, siehe mikroNachAntwort in
 * shared/mikro-nach-antwort.ts — dort auch das kürzere Fenster bei
 * „vermutlich Schluss“). 0 = aus: das Mikro bleibt offen wie bisher,
 * bis Wort, Stille oder Knopf.
 *
 * 26.09.2026 abends: aus frontend/lib/settings.ts hierher, damit der Server
 * (settings-sanitize.ts) genau diese Stufen zulässt — vorher stand dort eine
 * eigene Spanne 2–5 s, die auch 2500 annahm. Zwei Besitzer derselben Regel.
 */
export const NACHLAUSCH_STUFEN: readonly number[] = [0, 2000, 3000, 4000, 5000];
export const NACHLAUSCH_VORGABE_MS = 3000;

/** Ist das eine der Stufen? */
export function istNachlauschStufe(ms: unknown): ms is number {
  return typeof ms === "number" && NACHLAUSCH_STUFEN.includes(ms);
}

/** Die gültige Fensterlänge; ein Wert ohne eigene Stufe führt auf die Vorgabe. */
export function nachlauschFenster(ms: unknown): number {
  return istNachlauschStufe(ms) ? ms : NACHLAUSCH_VORGABE_MS;
}

/**
 * 17.10.2026 (Messung 6 h, Fälle B/C): Nach einer ECHTEN Frage schloss das 3-s-Fenster (`nachlauschen-zu gesprochen=nein`),
 * bevor Martin zu antworten begann. Nur das Öffnen nach einer offenen Frage (mikroNachAntwort, Grund frage/notsatz-bitte) hört
 * mindestens so lange zu; „0 = aus“ bleibt aus, ein längeres eingestelltes Fenster bleibt, alle anderen Gründe unverändert.
 */
export const NACHLAUSCH_FRAGE_MS = 6000;
export function nachlauschNachFrage(fensterMs: number): number {
  return fensterMs > 0 ? Math.max(fensterMs, NACHLAUSCH_FRAGE_MS) : 0;
}
